module.exports = __webpack_public_path__ + "img/WordPress.506c415f.png";